
import {FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip} from "@mui/material";
import Person from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import {ErrorMessage} from "formik";
import PostcodeIcon from "@mui/icons-material/LocalPostOfficeRounded";
import * as React from "react";
import {Fragment} from "react";
import {HelpOutline} from "@mui/icons-material";

export function InstallAddress({ values, handleChange, errors, data }) {

  return (

    <Fragment>

      <h5 className="text-secondary mb-3">Installation Address <Tooltip title="What address will the product be installed at?" arrow><HelpOutline /></Tooltip></h5>
      {data.shipping === '0' && <p style={{height:'35px'}}>&nbsp;</p>}
      <FormControl fullWidth className="mb-4">
        <TextField name="install_firstname"
                   label="Install  Firstname"
                   value={values.install_firstname}
                   onChange={handleChange}
                   error={!!Boolean(errors.install_firstname)}
                   helperText={errors.install_firstname}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><Person/></InputAdornment>
                     )
                   }}
        />

      </FormControl>


      <FormControl fullWidth className="mb-4">
        <TextField name="install_lastname" label="Install  Lastname" variant="outlined"
                   onChange={handleChange}
                   value={values.install_lastname}
                   error={!!Boolean(errors.install_lastname)}
                   helperText={errors.install_lastname}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><Person/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <TextField name="install_phone" label="Install  Phone"
                   onChange={handleChange}
                   value={values.install_phone}
                   error={!!Boolean(errors.install_phone)}
                   helperText={errors.install_phone}
                   InputProps={{
                     startAdornment: (<InputAdornment position='start'><PhoneIcon/></InputAdornment>)
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <TextField name="install_email" label="Install  Email Address"
                   onChange={handleChange}
                   value={values.install_email}
                   error={!!Boolean(errors.install_email)}
                   helperText={errors.install_email}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><EmailIcon/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <TextField name="install_street" label="Install  Street Number & Name"
                   onChange={handleChange}
                   value={values.install_street}
                   error={!!Boolean(errors.install_street)}
                   helperText={errors.install_street}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><HomeIcon/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <TextField name="install_suburb_town" label="Install  Suburb or Town"
                   onChange={handleChange}
                   value={values.install_suburb_town}
                   error={!!Boolean(errors.install_suburb_town)}
                   helperText={errors.install_suburb_town}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><HomeIcon/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

      <FormControl fullWidth className="mb-4">
        <InputLabel id="install-state-label">State</InputLabel>
        <Select name="install_state"
                labelId="install-state-label"
                value={values.install_state}
                id="install-state"
                label="State"
                variant="outlined"
                onChange={handleChange}
                error={!!Boolean(errors.install_state)}
        >
          <MenuItem selected value=""><em>None</em></MenuItem>
          <MenuItem value="ACT">Australian Capital Territory</MenuItem>
          <MenuItem value="NSW">New South Wales</MenuItem>
          <MenuItem value="NT">Northern Territory</MenuItem>
          <MenuItem value="QLD">Queensland</MenuItem>
          <MenuItem value="SA">South Australia</MenuItem>
          <MenuItem value="TAS">Tasmania</MenuItem>
          <MenuItem value="VIC">Victoria</MenuItem>
          <MenuItem value="WA">Western Australia</MenuItem>
        </Select>
        <ErrorMessage style={{letterSpacing: '0.03333em', fontSize: '0.75rem', marginLeft: '14px'}}
                      component="div" name="install_state" className="help-block errors text-danger"/>
      </FormControl>

      <FormControl fullWidth className="mb-5">
        <TextField name="install_postcode" label="Install  Postcode"
                   onChange={handleChange}
                   value={values.install_postcode}
                   error={!!Boolean(errors.install_postcode)}
                   helperText={errors.install_postcode}
                   InputProps={{
                     startAdornment: (
                       <InputAdornment position='start'><PostcodeIcon/></InputAdornment>
                     )
                   }}
        />
      </FormControl>

    </Fragment>
  );

}